package com.downdogapp.client.widget

import com.downdogapp.*
import com.downdogapp.Color.Companion.WHITE
import com.downdogapp.Size.Companion.percent
import com.downdogapp.Size.Companion.px
import org.w3c.dom.*
import kotlin.contracts.ExperimentalContracts
import kotlin.contracts.InvocationKind.EXACTLY_ONCE
import kotlin.contracts.contract

class SettingsFormField(parent: HTMLElement,
                        private val isPassword: Boolean = false) {

  private var outerContainer: HTMLDivElement
  private var labelElement: HTMLSpanElement
  private var inputBox: HTMLInputElement

  var label: String? = null
    set(value) {
      field = value
      labelElement.text = value?.uppercase()
    }

  val value get() = inputBox.value

  init {
    parent.apply {
      outerContainer = div {
        labelElement = label(fontSize = 16, fontWeight = FontWeight.SEMIBOLD)

        div {
          inputBox = input {
            (this as HTMLElement).width = percent(100)
            (this as HTMLElement).height = px(60)

            type = if (isPassword) "password" else ""

            marginTop = px(10)
            marginBottom = px(10)

            bgColor = WHITE
            border = Border.solid(px(14), WHITE)
            txtColor = Color.DARK_GREY
            borderRadius = px(6)

            fontFamily = FONT_FAMILY
            fontWeight = FontWeight.MEDIUM
            fontSize = if (isPassword) px(48) else px(17)
          }
        }
      }
    }
  }

  fun focus() {
    inputBox.focus()
  }

  fun setText(text: String) {
    inputBox.value = text
  }
}

@OptIn(ExperimentalContracts::class)
fun HTMLDivElement.settingsFormField(isPassword: Boolean = false,
                                     block: SettingsFormField.() -> Unit = {}): SettingsFormField {
  contract {
    callsInPlace(block, EXACTLY_ONCE)
  }
  return SettingsFormField(
    parent = this,
    isPassword = isPassword
  ).apply(block)
}
